import { render, staticRenderFns } from "./ModalCloseButton.vue?vue&type=template&id=1ffb9d48&scoped=true&"
import script from "./ModalCloseButton.vue?vue&type=script&lang=js&"
export * from "./ModalCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalCloseButton.vue?vue&type=style&index=0&id=1ffb9d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb9d48",
  null
  
)

export default component.exports